import React from 'react';
import ReviseTextButton from "./revise-text/revise-text-button";
import FormField from "./react-hook-form/form-field";

const TextCorrectorComponent = ({children, setIsLoading, name, module, url, setState, disable}) => {
    return (
        <>
            {children}

            <FormField
                name={name}
                customRender={field => (
                    <ReviseTextButton
                        value={field.value}
                        setValue={(value) => setState(prev => ({ ...prev, [name]: value ?? null })) }
                        setIsLoading={setIsLoading}
                        module={module}
                        url={url}
                        disable={disable}
                    />
                )}
            />
        </>
    );
};

export default TextCorrectorComponent;